import { useEffect } from 'react';

export function useScrollEffects() {
  useEffect(() => {
    const progress = document.getElementById('scroll-progress');
    const header = document.getElementById('site-header');
    const blob1 = document.querySelector<HTMLDivElement>('.hero-blob-1');
    const blob2 = document.querySelector<HTMLDivElement>('.hero-blob-2');
    let ticking = false;

    function onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      if (progress) progress.style.width = pct + '%';

      if (header) {
        if (scrollTop > 20) header.classList.add('header-scrolled');
        else header.classList.remove('header-scrolled');
      }

      if (blob1) blob1.style.transform = `translateY(${scrollTop * 0.15}px)`;
      if (blob2) blob2.style.transform = `translateY(${scrollTop * -0.1}px)`;

      ticking = false;
    }

    function handler() {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }

    window.addEventListener('scroll', handler, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', handler);
  }, []);
}
